<template>
  <transition name="fade" mode="out-in" appear>
    <div class="comp-modal-contact">
      
      <div
      v-on:click="onClickBackground" ontouchstart=""
      class="modal-background"></div>

      <div class="modal-window">

        <div class="modal-header">{{name}}</div>
        <div class="modal-body">
          <div
          v-on:click="makePhoneCall(phone)" ontouchstart=""
          class="action-btn">
            <div class="btn-icon">
              <comp-icon
              v-bind:icon="'phone'"
              v-bind:width="24"></comp-icon>
            </div>
            <div class="btn-text">{{phone}}</div>
          </div>
          <div
          v-on:click="sendEmail(email)" ontouchstart=""
          class="action-btn">
            <div class="btn-icon">
              <comp-icon
              v-bind:icon="'mail'"
              v-bind:width="24"></comp-icon>
            </div>
            <div class="btn-text">{{email}}</div>
          </div>
        </div>

      </div>

    </div>
  </transition>
</template>

<script>
import CompIcon from '@/components/CompIcon'
export default {
  name: 'comp-modal-contact',
  components: {
    CompIcon
  },
  props: {
    name: {
      type: String,
      required: true,
      default: function () {
        return null
      }
    },
    phone: {
      type: String,
      default: function () {
        return null
      }
    },
    email: {
      type: String,
      default: function () {
        return null
      }
    }
  },
  data: function () {
    return {
    }
  },
  created: function () {
  },
  computed: {
  },
  methods: {
    onCloseModal: function () {
      this.$emit('onClose', null)
    },
    onClickBackground: function () {
      this.onCloseModal()
    },
    makePhoneCall: function () {
      if (this.phone) {
        this.$tool.makePhoneCall(this.phone)
      }
    },
    sendEmail: function () {
      if (this.email) {
        this.$tool.sendEmail(this.email)
      }
    }
  }
}
</script>

<style scoped>
.comp-modal-contact {
  /* size */
  width: 100%;
  height: 100%;
  /* position */
  position: absolute;
  top: 0;
  left: 0;
}

.comp-modal-contact .modal-background {
  /* common */
  background-color: hsla(0, 0%, 0%, 1);
  opacity: 0.8;
  /* size */
  width: 100%;
  height: 100%;
  /* position */
  position: absolute;
  top: 0;
  left: 0;
}

.comp-modal-contact .modal-window{
  /* common */
  overflow: hidden;
  background: #fff;
  color: #000;
  box-shadow: 0 0 20px 2px rgba(0,0,0,0.5);
  /* text */
  text-align: center;
  /* shape */
  border-radius: 6px;
  /* size */
  max-width: 350px;
  width: calc(100% - 20px);
  /* position */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.comp-modal-contact .modal-window .modal-header {
  /* common */
  font-size: 1em;
  color: #fff;
  background-color: hsla(202, 100%, 50%, 1);
  /* text */
  font-weight: bold;
  /* size */
  padding: 1em;
  /* alignment */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

.comp-modal-contact .modal-window .modal-body {
  /* common */
  font-size: 1em;
}

.comp-modal-contact .modal-window .modal-body .action-btn {
  /* common */
  font-size: 1em;
  background-color: #fff;
  color: #000;
  /* mouse */
  cursor: pointer;
  /* size */
  border-top: 1px solid #eee;
  height: 4em;
  padding: 0 1em;
  /* alignment */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.comp-modal-contact .modal-window .modal-body .action-btn:hover {
  /* common */
  background-color: hsla(0, 0%, 95%, 1);
}

.comp-modal-contact .modal-window .modal-body .action-btn .btn-icon {
  /* common */
  color: hsla(202, 100%, 50%, 1);
  background-color: hsla(0, 0%, 95%, 1);
  /* size */
  padding: 0.2em;
  /* position */
  margin-right: 0.5em;
  /* shape */
  border-radius: 50%;
  border: 1px solid hsla(0, 0%, 90%, 1);
}
.comp-modal-contact .modal-window .modal-body .action-btn .btn-text {
  /* common */
  font-size: 1em;
}


</style>



// WEBPACK FOOTER //
// src/components/CompModalContact.vue